
import {mapActions, mapState} from 'vuex';
import { dateFormat } from '@/plugins/formatting';
import { getImageAllFormats } from '~/plugins/helpers/file';
import {reviewOpinion} from '~/plugins/enums/product';
import CustomRate from '~/components/elements/CustomRate';
import CustomImage from '~/components/elements/CustomImage';
import ReviewsCommentWrapper from '~/components/catalog/reviews/Comment/Wrapper';

export default {
  name: 'ReviewItem',
  components: {
    ReviewsCommentWrapper,
    CustomImage,
    CustomRate,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      vote: '',
      reviewOpinion,
      imageSizes: {
        mobile: [64, 64],
        pc: [80, 80],
      },
    }
  },
  computed: {
    ...mapState('productReviews', ['isLoading']),

    formattedDateTime() {
      const date = this.review.date;
      const dateTime = new Date(date);

      return dateFormat(
        dateTime,
        {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
        },
        'ru-RU',
      );
    },
    imageSize() {
      return this.mqIsMobile ? this.imageSizes.mobile : this.imageSizes.pc
    },
    isImages() {
      return this.reviewImages.length > 0
    },
    reviewImages() {
      const images = this.review.images || [];

      return images.filter(i => typeof(i) === 'number');
    },
    reviewLikes() {
      if (this.vote === this.reviewOpinion.LIKE) {
        return this.review.likes + 1
      }

      return this.review.likes
    },
    reviewDislikes() {
      if (this.vote === this.reviewOpinion.DISLIKE) {
        return this.review.dislikes + 1
      }

      return this.review.dislikes
    },
  },
  methods: {
    ...mapActions('productReviews', ['changeReviewVote']),
    async thumbClickHandler(opinion) {
      if (this.vote || this.isLoading.reviewsVote) return;

      await this.changeReviewVote({id: this.review.id, opinion})
      this.vote = opinion
    },
    getImageAllFormats,
    getImage(id, ext, width = '', height = '', src = '') {
      const image = this.getImageAllFormats(id, width, height, ext, src)

      return image[ext][0]
    },
  },
};
